export const sdgData = [
    {
        id: 'gender_imbalance',
        label: 'Popolazione Maschile',
        value: 69,
        unit: '%',
        description: 'La comunità è prevalentemente composta da uomini, con una presenza femminile del 31%.',
        color: '#0066cc'
    },
    {
        id: 'financial_inclusion',
        label: 'Inclusione Finanziaria',
        value: 77,
        unit: '%',
        description: 'Adulti titolari di un conto corrente (2020), in crescita rispetto al 69% del 2018.',
        color: '#4ecdc4'
    },
    {
        id: 'minors',
        label: 'Presenza Minori',
        value: 23.7,
        unit: '%',
        description: 'Incidenza di minori nella comunità, superiore alla media non comunitaria.',
        color: '#ffd93d'
    },
    {
        id: 'family_reason',
        label: 'Ingressi per Famiglia',
        value: 44,
        unit: '%',
        description: 'Principale motivo di ingresso nel 2021, segnale di stabilizzazione.',
        color: '#ff8a5b'
    },
    {
        id: 'work_permits_growth',
        label: 'Crescita Permessi Lavoro',
        value: 395,
        unit: '%',
        description: 'Aumento dei nuovi permessi per lavoro nel 2021 rispetto al 2020.',
        color: '#34c759'
    }
];
